export const getParameterItemsFromGroups = (groups = []) =>
  groups.flatMap((group) => (Array.isArray(group?.[1]) ? group[1] : []));

export const getActiveParameterSelection = (groups = []) => {
  const allParams = getParameterItemsFromGroups(groups);
  const checkedParams = allParams.filter((item) => item?.checked);
  const activeParams = checkedParams.length > 0 ? checkedParams : allParams;

  return {
    checkedIds: activeParams.map((item) => item.id),
    params: activeParams,
  };
};
